import { Container } from '@mui/material';
import { AddChallenge } from 'components/templates';
import React from 'react';

export const AddChallengeView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <AddChallenge />
    </Container>
  );
};
